import {
  ALL_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID
} from '../common/listingSections.js'
import {
  BUGGIES_CATEGORY1_ID,
  CLASSIC_MOTOS_CATEGORY1_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  QUADS_CATEGORY1_ID
} from '../motos/vehicleSpecifications/categories.js'

export const LISTING_SECTION_IDS_BY_CATEGORIES = {
  [BUGGIES_CATEGORY1_ID]: BUGGIES_VEHICLES_LISTING_SECTION_ID,
  [CLASSIC_MOTOS_CATEGORY1_ID]: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
  [MINIMOTOS_CATEGORY1_ID]: MINIMOTOS_VEHICLES_LISTING_SECTION_ID,
  [MOTOS_CATEGORY1_ID]: ALL_VEHICLES_LISTING_SECTION_ID,
  [QUADS_CATEGORY1_ID]: QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID
}

export const ARE_STOCK_FILTERS_AVAILABLE = false
